import { Deserialize } from 'src/utils';
import cookies from 'src/utils/cookie';
// import * as Sentry from '@sentry/browser';

// export const sentryIlog = (data, desc, tag) => {
//   Sentry.withScope((scope) => {
//     scope.setTag('fetch-alipay-tag', tag);
//     scope.setLevel(Sentry.Severity.Warning);
//     try {
//       Sentry.captureException({ data, msg: desc });
//     } catch (e) {}
//   });
// };
const jumpNavigateToAlipayPage = () => {
  const { channelContractNo = '' } = Deserialize(window.location.search);
  const serContractNo = cookies.get('channelContractNo') || channelContractNo;

  /* let url = encodeURIComponent(`https://render.alipay.com/p/yuyan/180020010001198920/medical-detail-bridge.html?serContractNo=${serContractNo}`);
  window.location.href = `https://ds.alipay.com/?scheme=${encodeURIComponent(`alipays://platformapi/startapp?appId=68687811&url=${url}`)}`;*/
  // 通知原生 webview页面要跳转 第三方小程序
  my && my.postMessage && my.postMessage({ action: 'NAVIGATETO_ANT_INS_DRUGS', data: { channelContractNo: serContractNo } });
};
// 通知支付宝唤起相册组件
export const notifyAlipayArouseChooseImage = (data) => {
  // eslint-disable-next-line @typescript-eslint/unbound-method
  console.log('postMessage', my.postMessage);
  my && my.postMessage && my.postMessage({ action: 'ALIPAY_APPLET_UPLOAD_IMAGE', data });
};

export default jumpNavigateToAlipayPage;
